export const blockIconsActionCheckCircleOutline = (
	<span className='material-symbols-outlined'>check_circle_outline</span>
);
